<template>
  <v-main>
    <v-layout
      v-if="$apollo.loading && !isQuizCheck"
      style="height:100vh;"
      justify-center
      align-center
      wrap
    >
      <v-progress-circular
        :size="70"
        :width="7"
        color="primary"
        indeterminate
      />
    </v-layout>
    <template v-if="!$apollo.loading">
      <core-warnings />
      <core-toolbar />
      <Drawer />
      <div
        id="core-view"
        :style="getUser && !getUser.onboarding ? 'padding-bottom: 60px' : ''"
      >
        <router-view :key="$route.path" />
      </div>
      <core-platform-progress v-if="getUser && !getUser.onboarding && !getIsSharingWhitelabels && !getIsInvite" />
      <helper-suspended />
    </template>
  </v-main>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import USER_SETTINGS_QUERY from "@/graphql/queries/UserSettings.gql";
import Drawer from "@/components/core/Drawer/Drawer.vue";

export default {
  components: {Drawer},
  computed: {
    ...mapGetters("user", ["getUser", "getIsSharingWhitelabels", "getIsInvite"]),
    isQuizCheck() {
      // Проверяем, не происходит ли проверка квиза
      return this.$route.name === "Quiz" || 
             (this.$route.name === "Dashboard" && this.$apollo.loading);
    },
  },
  methods: {
    ...mapMutations("user", ["setUserSettings"]),
  },
  apollo: {
    userSettings: {
      query: USER_SETTINGS_QUERY,
      pollInterval: 60 * 1000,
      result({ loading, data}) {
        if (!loading) {
          this.setUserSettings(data.userSettings)
        }
      }
    }
  }
}
</script>

<style>
.core-view  {
  padding-bottom: 60px;
}
</style>
